import { render, staticRenderFns } from "./PriceRangeSlider.vue?vue&type=template&id=671c730b&scoped=true&"
import script from "./PriceRangeSlider.vue?vue&type=script&lang=ts&"
export * from "./PriceRangeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./PriceRangeSlider.vue?vue&type=style&index=0&id=671c730b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c730b",
  null
  
)

export default component.exports